// src/components/ConfirmacaoAgendamento.js
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default function ConfirmacaoAgendamento({ show, onClose, onConfirm, resumo }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Agendamento</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p><strong>Serviço:</strong> {resumo.servico || '—'}</p>
        <p><strong>Profissional:</strong> {resumo.funcionario || '—'}</p>
        <p><strong>Data:</strong> {resumo.data || '—'}</p>
        <p><strong>Horário:</strong> {resumo.hora || '—'}</p>
        <p><strong>WhatsApp:</strong> {resumo.telefone || '—'}</p>
        {resumo.observacao && (
          <p><strong>Observação:</strong> {resumo.observacao}</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={() => {
            onConfirm();  
          }}
        >
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
